var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4.875C21.8219 4.875 17.7376 6.11396 14.2636 8.4352C10.7896 10.7564 8.08196 14.0557 6.48305 17.9158C4.88415 21.7759 4.46581 26.0234 5.28092 30.1213C6.09603 34.2191 8.10799 37.9832 11.0624 40.9376C14.0168 43.892 17.7809 45.904 21.8787 46.7191C25.9766 47.5342 30.2241 47.1159 34.0842 45.517C37.9443 43.918 41.2436 41.2104 43.5648 37.7364C45.886 34.2624 47.125 30.1781 47.125 26C47.1191 20.3991 44.8915 15.0293 40.9311 11.0689C36.9707 7.10848 31.6009 4.88091 26 4.875ZM34.2367 27.3366L23.6742 34.6491C23.4304 34.8177 23.1451 34.9164 22.8491 34.9345C22.5532 34.9525 22.258 34.8893 21.9954 34.7517C21.7329 34.614 21.513 34.4071 21.3595 34.1535C21.2061 33.8998 21.125 33.609 21.125 33.3125V18.6875C21.125 18.391 21.2061 18.1002 21.3595 17.8465C21.513 17.5929 21.7329 17.386 21.9954 17.2483C22.258 17.1107 22.5532 17.0475 22.8491 17.0655C23.1451 17.0836 23.4304 17.1823 23.6742 17.3509L34.2367 24.6634C34.4529 24.8129 34.6296 25.0126 34.7517 25.2454C34.8737 25.4782 34.9375 25.7372 34.9375 26C34.9375 26.2628 34.8737 26.5218 34.7517 26.7546C34.6296 26.9874 34.4529 27.1871 34.2367 27.3366Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.034a9c09acb20b2f05659da2ea506251.svg";
export { ForwardRef as ReactComponent };